import React from 'react';
import classNames from 'classnames';
import ActionButton from '../action-button';
import Heading from '../heading';
import Paragraph from '../paragraph';

const IntegrationItem = ({
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  imageSrc = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  imageAlt = null,
  title,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  description = null,
  isSelected = false,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '{ label?: string; onClick?: (...args: any[]) => any; iconGlyph?: string; format?: string; appearance?: string; }'.
  primaryButton = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '{ label?: string; onClick?: (...args: any[]) => any; iconGlyph?: string; format?: string; appearance?: string; }'.
  secondaryButton = null,
}) => (
  <div
    className={classNames('ws-ui-integration-item', {
      'ws-ui-integration-item--selected': isSelected,
    })}
  >
    {imageSrc && (
      <div className="ws-ui-integration-item__image-wrapper">
        <img alt={imageAlt} src={imageSrc} />
      </div>
    )}
    <div className="ws-ui-integration-item__content-wrapper">
      <div className="ws-ui-integration-item__content">
        {title && (
          <div className="ws-ui-integration-item__title">
            <Heading type="heading-6">{title}</Heading>
          </div>
        )}
        {description && (
          <div className="ws-ui-integration-item__description">
            <Paragraph size="small" appearance="medium-emphasis">
              {description}
            </Paragraph>
          </div>
        )}
      </div>
      <div className="ws-ui-integration-item__button-group">
        {primaryButton && primaryButton.onClick && (
          <ActionButton
            format={primaryButton.format}
            // @ts-ignore TS(2322): Type 'string | null' is not assignable to type 'nu... Remove this comment to see the full error message
            iconGlyph={primaryButton.iconGlyph || null}
            onClick={primaryButton.onClick}
            // @ts-ignore TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
            label={primaryButton.label}
            appearance={primaryButton.appearance}
          />
        )}
        {secondaryButton && secondaryButton.onClick && (
          <ActionButton
            format={secondaryButton.format}
            // @ts-ignore TS(2322): Type 'string | null' is not assignable to type 'nu... Remove this comment to see the full error message
            iconGlyph={secondaryButton.iconGlyph || null}
            onClick={secondaryButton.onClick}
            // @ts-ignore TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
            label={secondaryButton.label}
            appearance={secondaryButton.appearance}
          />
        )}
      </div>
    </div>
  </div>
);

export default IntegrationItem;
